module.exports = __webpack_public_path__ + "static/media/wsgdw.19e11bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wsgdw.jpg
// module id = 164
// module chunks = 0